import { Link } from 'react-router-dom';
import './retail.scss';

export default function RetailKeyMotivator() {
  return (
    <>
      <h5>Key Motivator for Retail Companies</h5>
      <p>Achieving a higher return on advertising spend (ROAS) would be retail companies’ top motivator for increasing direct mail use in the future.</p>

      <ul>
        <li>Experiment with the free <a href="/../rom-calculator/">marketing impact calculator</a> to get an idea of how much your direct mail campaigns could bring in—both for individual campaigns and in average lifetime value.</li>
      </ul>
    </>
  );
}
